import { AxiosInstance, AxiosPromise } from "axios";

import BaseApi from "api/base";

import {
  AnalyticsCTARequestData,
  HiveDetailsModel,
  OrganizationStory,
  OrganizationStoryItem,
  SegmentItemReactRequest,
  StoriesReactionRequest,
  StoriesRequest,
} from "../models/community";

import { BaseResponse } from "../models/base";

export class CommunityApi extends BaseApi {
  getHiveDetails(data: any): AxiosPromise<BaseResponse<HiveDetailsModel>> {
    return this.request({
      url: `webApp/${
        localStorage.getItem("isLoggedInFlag") === "yes" ? "hive/" : "noAuth/"
      }details`,
      method: "POST",
      data,
    });
  }

  getStories(
    data: StoriesRequest
  ): AxiosPromise<BaseResponse<OrganizationStory[]>> {
    return this.request({
      url: `webApp/noAuth/story/stories`,
      method: "POST",
      data,
    });
  }

  fetchCTALogs(data: AnalyticsCTARequestData): AxiosPromise<BaseResponse> {
    return this.request({
      url: `/spring/analytics/cta/${
        localStorage.getItem("isLoggedIn") === "yes" ? "auth" : "unAuth"
      }/update/logs`,
      method: "POST",
      data,
    });
  }

  getStoryItem(
    data: StoriesRequest
  ): AxiosPromise<BaseResponse<OrganizationStoryItem[]>> {
    return this.request({
      url: `webApp/noAuth/story/item`,
      method: "POST",
      data,
    });
  }

  updateStoryReaction(
    data: StoriesReactionRequest
  ): AxiosPromise<BaseResponse> {
    return this.request({
      url: `webApp/noAuth/story/react`,
      method: "POST",
      data,
    });
  }

  getSegmentItemReact(
    data: SegmentItemReactRequest
  ): AxiosPromise<BaseResponse> {
    return this.request({
      url: `webApp/noAuth/story/get/react`,
      method: "POST",
      data,
    });
  }
}

export default function communityApi(request: AxiosInstance) {
  return new CommunityApi({
    url: "/community",
    request,
  });
}
